import { Deserializable } from '../interfaces';

export class PeriodoDTO implements Deserializable {
  id?: string;
  nivelId?: string;
  sufijoPrograma?: string;
  nombre?: string;
  fechaPeriodoInicio?: string;
  fechaPeriodoFin?: string;
  fechaVacacionesInicio?: string;
  fechaVacacionesFin?: string;
  polizaNumero?: string;
  polizaFechaVigencia?: string;
  programa: string;
  nombreNivel: string;
  activo: boolean;
  esSemestreEmpresarial: boolean;

  constructor() {
    this.id = '';
    this.nombre = '';
    this.fechaPeriodoInicio = null;
    this.fechaPeriodoFin = null;
    this.fechaVacacionesInicio = null;
    this.fechaVacacionesFin = null;
    this.polizaNumero = '';
    this.polizaFechaVigencia = null;
    this.activo = false;
    this.nivelId = '';
    this.programa = '';
    this.nombreNivel = '';
    this.sufijoPrograma = '';
    this.esSemestreEmpresarial = false;
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}

export class Periodo implements Deserializable {
  periodoId?: string;
  nivelId?: string;
  sufijoPrograma?: string;
  nombre?: string;
  fechaPeriodoInicio?: string;
  fechaPeriodoFin?: string;
  fechaVacacionesInicio?: string;
  fechaVacacionesFin?: string;
  polizaNumero?: string;
  polizaFechaVigencia?: string;
  activo: boolean;
  fechaCreacion?: string;
  usuarioCreacion?: string;
  fechaModificacion?: string;
  usuarioModificacion?: string;
  esSemestreEmpresarial: boolean;

  constructor() {
    this.periodoId = '';
    this.nivelId = '';
    this.sufijoPrograma = '';
    this.nombre = '';
    this.fechaPeriodoInicio = null;
    this.fechaPeriodoFin = null;
    this.fechaVacacionesInicio = '';
    this.fechaVacacionesFin = '';
    this.polizaNumero = '';
    this.polizaFechaVigencia = '';
    this.activo = false;
    this.fechaCreacion = '';
    this.usuarioCreacion = '';
    this.fechaModificacion = '';
    this.usuarioModificacion = '';
    this.esSemestreEmpresarial = false;
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}

export class PeriodoBanner implements Deserializable {
  /* La propiedad stvTermCode es la id del periodo obtenido en banner*/
  stvTermCode?: string;
  /* La propiedad stvTermDesc es el nombre del periodo obtenido en banner*/
  descPeriodo?: string;
  fechaInicial?: string;
  fechaFinal?: string;
  fechaInicialVacacional?: string;
  fechaFinalVacacional?: string;

  constructor() {
    this.stvTermCode = null;
    this.descPeriodo = null;
    this.fechaInicial = null;
    this.fechaFinal = null;
    this.fechaInicialVacacional = null;
    this.fechaFinalVacacional = null;
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
